export default __webpack_public_path__ + "static/logo-heineken-9ab85f8eeb15e730fe21d581a73bcf2a.svg";